export const CUSTOM_BACKGROUND_UPLOADER_CONFIG = {
  MAX_FILE_SIZE: 10 * 1024 * 1024,
  SUPPORTED_FORMATS: ['image/*'],
  MAX_NUMBER_OF_FILES: 1,
};
